import { useEffect, useRef } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { App, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const UPDATE_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes
const NOTIFICATION_KEY = "app-update-available";

export function UpdatePrompt() {
  const { notification } = App.useApp();

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => registration.update(), UPDATE_CHECK_INTERVAL);
    },
  });

  // Latest-value refs: the prompt must fire only when `needRefresh` flips —
  // re-running on a new `notification`/`updateServiceWorker` identity would
  // re-raise the notification.
  const notificationRef = useRef(notification);
  const updateServiceWorkerRef = useRef(updateServiceWorker);

  // Declared before the prompt effect so it runs first in every commit — the
  // refs therefore hold the current render's values when the prompt reads them.
  useEffect(() => {
    notificationRef.current = notification;
    updateServiceWorkerRef.current = updateServiceWorker;
  });

  useEffect(() => {
    if (!needRefresh) return;
    const notify = notificationRef.current;
    const update = updateServiceWorkerRef.current;
    notify.info({
      key: NOTIFICATION_KEY,
      message: "Nowa wersja dostępna",
      description: "Odśwież stronę, aby załadować najnowszą wersję aplikacji.",
      duration: 0,
      btn: (
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={() => update(true)}
        >
          Odśwież
        </Button>
      ),
    });
  }, [needRefresh]);

  return null;
}
